import React from 'react';
import { selectedPeriodVar } from 'app/apollo/reaction';
import { toUTS } from 'global/utils';
import { useReactiveVar } from '@apollo/client';
import { TCurrentSetType } from './components/BasketSetsSelection/BasketSetsSelection';

export const useBigSetBannerByPeriod = (): TCurrentSetType => {
    const period = toUTS(useReactiveVar(selectedPeriodVar));

    if (period >= toUTS('2025-09-07') && period < toUTS('2025-10-05')) {
        return 'film';
    }

    if (period >= toUTS('2025-11-03') && period < toUTS('2025-11-30')) {
        return 'hp';
    }

    if (period >= toUTS('2026-01-26') && period < toUTS('2026-02-16')) {
        return 'romantic';
    }

    if (period >= toUTS('2026-02-16') && period < toUTS('2026-02-23')) {
        return 'maslenitsa';
    }

    if (period >= toUTS('2026-02-23') && period < toUTS('2026-03-02')) {
        return 'fast';
    }

    if (period >= toUTS('2026-03-02') && period < toUTS('2026-03-16')) {
        return 'march';
    }

    if (period >= toUTS('2026-03-16') && period < toUTS('2026-04-12')) {
        return 'easter';
    }

    if (period >= toUTS('2026-04-27') && period < toUTS('2026-07-12')) {
        return 'dacha';
    }

    if (period >= toUTS('2026-07-13') && period < toUTS('2026-08-09')) {
        return 'odyssey';
    }

    if (period >= toUTS('2026-08-07') && period < toUTS('2026-08-21')) {
        return 'gryadka';
    }

    if (period >= toUTS('2026-08-31') && period < toUTS('2026-10-04')) {
        return 'school';
    }

    if (period >= toUTS('2026-10-12') && period < toUTS('2026-11-01')) {
        return 'halloween';
    }

    if (period >= toUTS('2026-11-02') && period < toUTS('2026-11-15')) {
        return 'harry';
    }

    return 'green';
};


// if (period >= toUTS('2025-06-23') && period < toUTS('2025-07-20')) {
//     return 'squidgame';
// }

// if (period >= toUTS('2025-12-01') && period < toUTS('2026-01-11')) {
//     return 'ny';
// }

// if (period >= toUTS('2026-02-23') && period < toUTS('2026-03-02')) {
//     return 'marchgifts';
// }
